import React from 'react';

import { ExtendedReportTemplateList } from '@futrli/views/processors/reports/reportTemplatesList';
import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';

import { useDashboardTemplateActionItems } from './hooks/use-dashboard-template-action-items';

interface DashboardTemplateActionsPopoverProps {
  template: ExtendedReportTemplateList;
  onDelete?: () => void;
  onPublish?: () => void;
}

export const DashboardTemplateActionsPopover = ({ template, onDelete, onPublish }: DashboardTemplateActionsPopoverProps) => {
  const items = useDashboardTemplateActionItems({ template, onDelete, onPublish });

  return <ListingPageRowActions items={items} />;
};
